// extracted by mini-css-extract-plugin
export default {"link":"Home_link__sRlmO","header":"Home_header__cmrcA","headline":"Home_headline__9zvCr","search":"Home_search__u+BHH","searchResult":"Home_searchResult__HBt2D"};